import React, { useState } from "react";
import BriefCase from "assets/icons/BriefCase.svg";
import Star from "assets/icons/Star.svg";
import ChatDots from "assets/icons/ChatDots.svg";
import CurrencyDollar from "assets/icons/CurrencyDollar.svg";
import CustomPagination from "./Pagination";
import { statusColors } from "../../constant/Home/Common";
import { formatCurrency } from "../../utils/utils";

const OfferListCards = ({
  resultsPerPage = 9,
  offers,
  classGrid = "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  showPagination = true,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(offers.length / resultsPerPage);

  const pagesToShow = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "-", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "-", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "-", currentPage, "-", totalPages);
      }
    }
    return pages;
  };

  const goToPage = (page) => {
    if (page === "-" || page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const renderCard = (offer) => (
    <div
      key={offer.id}
      className="w-full bg-[#FDFDFD] rounded-[16px] border border-[#ECECEC] p-4 shadow-sm flex flex-col gap-4"
    >
      <div className="flex justify-between items-start sm2:flex-row flex-col gap-y-2">
        <div className="flex gap-4 items-center ">
          <img
            src={offer.image}
            alt="avatar"
            className="w-11 h-11 rounded-full object-cover"
          />
          <h3 className="font-medium text-[#242424]">James Plumbing Co.</h3>
        </div>
        <span
          className={`text-[12px]  px-3 py-1 border rounded-full font-medium ${
            statusColors[offer.status]
          }`}
        >
          • {offer.status}
        </span>
      </div>

      <div className="text-sm text-gray-700 space-y-2">
        <p className="flex justify-between items-center">
          <span className="flex items-center gap-2 font-medium text-[14px] text-[#595959] ">
            <img src={BriefCase} className="w-4 h-4 " alt="Job Icon" /> Job
            Title:
          </span>
          <span className=" text-[14px]  text-[#242424]">{offer.jobTitle}</span>
        </p>
        <p className="flex justify-between items-center">
          <span className="flex items-center gap-2 font-medium text-[14px] text-[#595959] ">
            <img src={Star} className="w-4 h-4 " alt="Star Icon" /> Ratings:
          </span>
          <span className=" text-[14px]  text-[#242424]">{offer.rating}/5</span>
        </p>
        <p className="flex justify-between items-center">
          <span className="flex items-center gap-2 font-medium text-[14px] text-[#595959] ">
            <img src={CurrencyDollar} className="w-4 h-4 ]" alt="Dollar Icon" />{" "}
            Quote Amount:
          </span>
          <span className=" text-[14px]  text-[#242424]"> {formatCurrency(offer.quote)}</span>
        </p>
        <p className="flex justify-between items-center">
          <span className="flex items-center gap-2 font-medium text-[14px] text-[#595959] ">
            <img
              src={ChatDots}
              className="w-4 h-4 text-[#595959]"
              alt="Chat Icon"
            />{" "}
            Response Time:
          </span>
          <span className=" text-[14px]  text-[#242424]">{offer.response}</span>
        </p>
      </div>

      <div className="flex md:gap-4 gap-2 w-full ">
        <button className="rounded-[12px] border border-[#ECECEC] w-full bg-[#F8F8F8] text-center text-[14px] md:text-[16px] text-[#242424] hover:bg-gray-100">
          View offer
        </button>
        <button className="border rounded-[12px] w-full bg-[#3CAB5C] text-center text-[14px] md:text-[16px] text-white hover:bg-gray-100">
          Accept offer
        </button>
      </div>
    </div>
  );

  return (
    <div className="w-full md:py-4 py-2">
      <div className={`grid ${classGrid} md:gap-4 gap-2`}>
        {offers
          .slice(
            (currentPage - 1) * resultsPerPage,
            currentPage * resultsPerPage
          )
          .map(renderCard)}
      </div>

      {showPagination && (
        <CustomPagination
          resultsPerPage={resultsPerPage}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        ></CustomPagination>
      )}
    </div>
  );
};

export default OfferListCards;
